{
  "version": 1,
  "asset_id": "0ebe8a91-cae0-44bb-8593-e063eddbf4dd",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/0ebe8a91-cae0-44bb-8593-e063eddbf4dd/ndlcs-services-flyer.png",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/0ebe8a91-cae0-44bb-8593-e063eddbf4dd/ndlcs-services-flyer.png",
  "original_filename": "ndlcs-services-flyer.png",
  "size": 1842339,
  "content_type": "image/png",
  "created_at": "2026-07-02T17:49:57Z"
}
